import { useState, useEffect, useRef } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { api } from '../../services/api'
import { AuthContainer, AuthCard, Divider, BackText, StyledLink, LoadingSpinner, StatusIcon } from './styles'

export function VerifyEmail() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [status, setStatus] = useState('loading') // loading, success, error
  const [message, setMessage] = useState('')
  const hasVerified = useRef(false)

  useEffect(() => {
    const verifyEmail = async () => {
      if (hasVerified.current) return
      hasVerified.current = true

      const token = searchParams.get('token')

      if (!token) {
        setStatus('error')
        setMessage('Token de verificação não fornecido.')
        return
      }

      try {
        const { data } = await api.post('/auth/verify-email', { token })
        setStatus('success')
        setMessage(data.message || 'Email verificado com sucesso!')
        toast.success('Email verificado! Você já pode fazer login.')

        setTimeout(() => {
          navigate('/login')
        }, 3000)
      } catch (error) {
        setStatus('error')
        if (error.response?.status === 400) {
          setMessage(error.response.data?.message || 'Token inválido ou expirado.')
        } else {
          setMessage('Erro ao verificar email. Tente novamente.')
        }
        toast.error('Falha na verificação do email.')
      }
    }

    verifyEmail()
  }, [searchParams, navigate])

  if (status === 'loading') {
    return (
      <AuthContainer>
        <AuthCard>
          <h1>Verificando Email</h1>
          <p>Aguarde enquanto verificamos seu email...</p>
          <LoadingSpinner />
        </AuthCard>
      </AuthContainer>
    )
  }

  if (status === 'success') {
    return (
      <AuthContainer>
        <AuthCard>
          <StatusIcon>✓</StatusIcon>
          <h1>Email Verificado!</h1>
          <p>{message}</p>
          <p>Redirecionando para a página de login...</p>

          <Divider />

          <BackText>
            <StyledLink to="/login">Ir para Login agora</StyledLink>
          </BackText>
        </AuthCard>
      </AuthContainer>
    )
  }

  return (
    <AuthContainer>
      <AuthCard>
        <StatusIcon>✗</StatusIcon>
        <h1>Verificação Falhou</h1>
        <p>{message}</p>

        <Divider />

        <BackText>
          <StyledLink to="/resend-verification">Reenviar email de verificação</StyledLink>
          {' · '}
          <StyledLink to="/register">Criar nova conta</StyledLink>
        </BackText>
      </AuthCard>
    </AuthContainer>
  )
}
